module.exports = __webpack_public_path__ + "img/Künstlerin.ad9fd8a8.jpg";